// extracted by mini-css-extract-plugin
export default {"containerDetail":"Detail_containerDetail__0RqCX","infoDetail":"Detail_infoDetail__TJvmJ","loadingDetail":"Detail_loadingDetail__HFGC-","girar":"Detail_girar__aeiKj"};